module.exports = __webpack_public_path__ + "img/Adaptable.fbbce7b1.png";